import { Box, css } from '@mui/material'
import styled from '@emotion/styled'

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-direction: column-reverse;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
    }
  `}
`
